<template>

    <div class="langmain" style="position:static">
        <img  class="bkg-image" src="@/assets/welcome.jpg">
            <v-container>
                <div>
                    <div >
                        <v-row  class="top-space" style="justify-content: space-around;">
                            <div>
                                <v-container class="btpadidng">
                                <v-col cols="12" v-for="businesslanguage in businesslanguages">
                                        <v-row>
                                            <v-card style="position:relative" elevation=24 class="langcard pa-0 ma-0">
                                                <v-row cols="12" md="12" class="pa-0 ma-0">
                                                <v-col>
                                                    <v-row no-gutters dense class="ma-0 pa-0" @click="fetchlang(businesslanguage.languagecode)">
                                                        <v-col cols="3" md="3" class="pa-1 ma-0">
                                                            <!-- <v-img contain src="https://api.juzzap.com/storage/flags/gb.svg"></v-img> -->
                                                            <!-- <v-img width="35" height="35" :src="businesslanguage.photo"  :alt="businesslanguage.languagecode"  ></v-img> -->
                                                            <!-- <img :src="businesslanguage.photo"  :alt="businesslanguage.languagecode" style="width:25px;height:25px"/> -->
                                                            <!-- <v-img> -->
                                                            <img :src="businesslanguage.photo"  :alt="businesslanguage.languagecode"/>
                                                            <!-- </v-img> -->
                                                        </v-col>
                                                        <v-col cols="9" md="9" class="pa-1 ma-0">
                                                            <v-row no-gutters dense class="pa-0 ma-0">
                                                                <span class="country-name ma-0 pa-0">{{businesslanguage.lname}}</span>
                                                            </v-row>
                                                            <v-row no-gutters dense class="pa-0 ma-0">
                                                                <span style="position:absolute; top:15px; right:5px; text-transform:uppercase" class="short-lang-code text-right mt-n3">{{businesslanguage.languagecode}}</span>
                                                                <!-- <span  class="welcome pa-0 ma-0">{{$t('zz_welcome')}}</span> -->
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                </v-row>
                                        </v-card>
                                    </v-row>
                                </v-col>
                                </v-container>
                            </div>
                        </v-row>
                    </div>
                    <p class="powered-by-juzzap">powered by juZZap<br>Languagescode</p>
                </div>
            </v-container>
         <!-- </img> -->
    </div>
</template>
<script>



import Vue from 'vue'
import VeeValidate from "vee-validate"


import {TheMask} from 'vue-the-mask'

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: () =>
    ({

      businesslanguages:[],
      business_id:'',

  }),
  created()
  {
      this.business_id=localStorage.getItem('business_id');
      this.fetchlanguage();
  },

  methods:
  {
        fetchlanguage()
        {
                this.$http.get(this.$apidomain+"businesslanguages/" + this.business_id)
                .then(res=>{

                        if (res.data.success == 1)
                        {

                                this.businesslanguages=res.data.businesslanguages;

                        }

                })
                .catch(err=>{
                console.log(err.response);
                });
        },
      fetchlang(languagecode)
      {
        localStorage.setItem('langcode-'+this.business_id,languagecode);
        this.$router.push({name:'food'});

      }

  },
}
</script>
<style scoped>

.bkg-image{

    height: 100vh;
    background-size: cover;
    position: fixed !important;
    top: 0px !important;

}
.btpadidng{
    padding-bottom: 75px !important;
}
.scrolling{
    overflow: overlay;
    /* overflow:auto; */
}
.top-space{
    margin-top: 50px;
    /* padding-bottom: 250px; */

}

.langcard{
    min-width: 80vw;

    /* width: 80%; */
    /* margin-top: 10px !important; */
    /* margin-bottom: 10px !important; */
    background-color: rgb(240, 240, 240);
    max-height: clamp(25px, 150px);
    padding: 0px !important;
    margin:0px !important;
    border-radius: 3px !important;

}
.powered-by-juzzap{
    position: absolute;
    bottom: 95vh;
    right: 10px
}

.flagicon{
    /* align-self: center; */
    width: 100%;

}
.short-lang-code{
    font-size: 8px !important;
    font-weight: 400;
}
.country-name{
    font-size: clamp(20px, 10vw, 100px);
    font-weight: 600;
    /* padding-bottom: 1px !important; */
    /* padding-top: 6px !important; */
    text-transform: uppercase;

}
 .welcome{
     font-size: clamp(12px, 2vw, 70px);
     font-weight: 300;
     padding-top: -10px !important;
     /* padding-bottom: 0px !important; */
 }


.mt-8{
    padding-top: 50px;
}
.mb-8
{
    margin-bottom: 50px;
}
.para
{
    text-align:justify;
    padding-top:10px;
}
.primarycolor{
    color:red !important;
}
.mt-50
{
    margin-top:50px !important;
}
.theme--light.v-application {
    background: #fff;

}
.pwa-div{
    margin-top: -60px;
}
.custom-placeholer-color input::placeholder {
  color: red!important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: red;
  opacity: 1;
}

.pin-separator{
    font-size:20px;
}
.pin-box{
    font-size:20px;
    padding: 8px 12px;
    width:100%;
    border: 1px solid #dddddd;
    text-align: center;
}

 .langmain .imagezoomfast{
  animation: beat 35s infinite alternate;
  /* animation:scale 60s forwards; */
  transform-origin:50% 50%;
  transform:scale(1);

}


.langmain .imagezoomslow{

  animation: beat 30s infinite alternate;
  /* animation:scale 75s forwards; */
  transform-origin:50% 50%;
  transform:scale(1);

}
</style>
